import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./features/home/Home";
import Profile from "./features/profile/Profile";
import EditProfile from "./features/profile/EditProfile";
import Shop from "./features/shop/Shop";
import Login from "./features/auth/Login";
import Category from "./features/category/Category";
import Search from "./features/search/Search";
import ShopCart from "./features/shop/cart/ShopCart";
import CartOrder from "./features/shop/cartOrder/CartOrder";
import Map from "./features/map/Map";
import Addresses from "./features/addresses/Addresses";
import AddressDetail from "./features/addresses/AddressDetail";
import Factor from "./features/shop/factor/Factor";
import NotFound from "./base/features/pages/notFound/NotFound";
import Orders from "./features/orders/Orders";
import OrderDetail from "./features/orders/OrderDetail";
import Setting from "./features/setting/Setting";
import Carts from "./features/carts/Carts";
import TermsOfUse from "./features/termsOfUse/TermsOfUse";
import PersonalizedProduct from "./features/shop/personalizedProduct/PersonalizedProduct";
import Feedback from "./features/feedback/Feedback";
import Product from "./features/shop/product/Product";
import AddComment from "./features/shop/comment/AddComment";
import Products from "./features/shop/products/Products";
import DashBoard from "./features/management/dashboard/DashBoard";
import ManagementComments from "./features/management/comments/ManagementComments";
import EditShop from "./features/management/editShop/EditShop";
import ShopTerms from "./features/management/shopTerms/ShopTerms";
import TermDetail from "./features/management/shopTerms/TermDetail";
import ProductDetail from "./features/management/product/ProductDetail";
import ManagementOrders from "./features/management/orders/ManagementOrders";
import ManagementOrderDetail from "./features/management/orderDetail/ManagementOrderDetail";
import { clients_config } from "./base/services/services";
import version from "./settings/version";
import ShopManagers from "./features/management/managers/ShopManagers";
import ManagersDetail from "./features/management/managers/ManagersDetail";
import AddShop from "./features/addShop/AddShop";
import ShopActivation from "./features/management/activation/ShopActivation";
import { profileDetail } from "./features/profile/services";
import ManagerConnections from "./features/management/managerConnections/ManagerConnections";
import ConnectionDetail from "./features/management/managerConnections/ConnectionDetail";
import ManagementProducts from "./features/management/products/ManagementProducts";
import Categories from "./features/categories/Categories";
import Customers from "./features/management/customers/Customers";
import CustomerCartsDetail from "./features/management/customer/customerCartsDetail/CustomerCartsDetail";
import CustomerProfile from "./features/management/customer/profile/CustomerProfile";
import ProductSearch from "./features/shop/product/ProductSearch";
import PostingMethods from "./features/management/posting/PostingMethods";
import PostingMethodDetail from "./features/management/posting/PostingMethodDetail";
import Payments from "./features/management/payments/Payments";
import UserCustomProducts from "./features/customProducts/UserCustomProducts";
import UserCustomProductsDetail from "./features/customProducts/UserCustomProductsDetail";
import { isAndroid, isIOS } from "react-device-detect";
import OpenAndroidModal from "./features/openAndroid/OpenAndroidModal";
import AfterPayment from "./features/afterPayment/AfterPayment";
import DynamicPage from "./features/DynamicPage/DynamicPage";
import { Helmet } from "react-helmet";
import { navigate_to_edit_profile } from "./navigator/user/profile";
import { isSiteDomain } from "./settings/domainManager";
import ShoppingConfigs from "./features/management/shoppingConfigs/ShoppingConfigs";
import NewShopCategory from "./features/management/newShopCategory";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      androidModal: false,
      selected_shop:
        localStorage.getItem("selected_shop") &&
        JSON.parse(localStorage.getItem("selected_shop")),
    };
  }
  get_profile_detail() {
    profileDetail().then((items) => {
      items &&
        !items.first_name &&
        !window.location.pathname.includes("editProfile") &&
        (window.location.href = navigate_to_edit_profile(
          window.location.pathname
        ));
    });
  }

  componentDidMount() {
    this.checkDevice();
    if (
      localStorage.getItem(`${window.location.hostname}_token`) &&
      !window.location.pathname.includes("dashboard")
    ) {
      this.get_profile_detail();
    }

    if (
      this.state.selected_shop &&
      !window.location.pathname.includes("dashboard") &&
      window.location.pathname === "/"
    ) {
      window.location.replace(`/dashboard/${this.state.selected_shop.uid}`);
    }
    let min_version = JSON.parse(localStorage.getItem("min_version_number"));
    clients_config("type=web").then((items) => {
      if (items) {
        try {
          localStorage.setItem(
            "login_items",
            JSON.stringify(items.login_items)
          );
        } catch {}

        if (version.versionNumber < items.min_version_number && !min_version) {
          localStorage.setItem("min_version_number", items.min_version_number);

          caches.keys().then((names) => {
            names.forEach((name) => {
              caches.delete(name);
            });
            window.location.reload(true);
          });
        } else if (
          min_version &&
          min_version < items.min_version_number &&
          version.versionNumber < items.min_version_number
        ) {
          localStorage.setItem("min_version_number", items.min_version_number);

          caches.keys().then((names) => {
            names.forEach((name) => {
              caches.delete(name);
            });
            window.location.reload(true);
          });
        }
      }
    });
  }
  componentWillMount() {
    localStorage.removeItem(`${window.location.hostname}_shops`);
    localStorage.removeItem(`${window.location.hostname}_next`);
    localStorage.removeItem(`${window.location.hostname}_scrollPosition`);
  }
  checkDevice() {
    let android_modal = localStorage.getItem("showGuide");
    if (
      // (isIOS || isAndroid) &&
      isAndroid &&
      !android_modal &&
      !window.matchMedia("(display-mode: standalone)").matches &&
      !isSiteDomain
    ) {
      localStorage.setItem("showGuide", 1);
      this.setState({ androidModal: true });
    }
  }
  render() {
    return (
      <div dir="rtl" className="row mx-0 px-0 justify-content-center">
        <Helmet>
          <title>گیتی مارکت | Gity Market</title>
          <meta
            name="description"
            content="فروشگاه‌ساز رایگان و بدون پورسانت"
          />
        </Helmet>
        <div className="col-12 col-sm-6 mx-0 px-0">
          <div id="loginModal"></div>
          {this.state.androidModal && (
            <OpenAndroidModal
              androidModal={this.state.androidModal}
              changeModal={(e) => this.setState({ androidModal: e })}
            />
          )}
          <Switch className="h-100">
            {isSiteDomain && <Route path="/" exact component={Shop} />}
            {!isSiteDomain && <Route path="/" exact component={Home} />}

            <Route
              path="/login"
              exact
              component={
                localStorage.getItem(`${window.location.hostname}_token`)
                  ? Home
                  : Login
              }
            />
            <Route path="/profile" exact component={Profile} />
            <Route
              path="/custom-products/:id"
              exact
              component={UserCustomProductsDetail}
            />
            <Route
              path="/custom-products"
              exact
              component={UserCustomProducts}
            />
            <Route path="/editProfile" exact component={EditProfile} />
            <Route path="/category" exact component={Category} />
            <Route path="/terms-of-use" exact component={TermsOfUse} />
            <Route path="/search" exact component={Search} />
            <Route path="/search/product" exact component={ProductSearch} />
            <Route path="/carts" exact component={Carts} />
            <Route path="/map" exact component={Map} />
            <Route path="/addresses" exact component={Addresses} />
            <Route path="/setting" exact component={Setting} />
            <Route path="/setting?seller=1" exact component={Setting} />
            <Route path="/orders" exact component={Orders} />
            <Route path="/feedback" exact component={Feedback} />

            <Route
              path="/dashboard/:id/comments"
              exact
              component={ManagementComments}
            />

            <Route
              path="/dashboard/:uid/orders/:id"
              exact
              component={ManagementOrderDetail}
            />
            <Route
              path="/dashboard/:uid/orders"
              exact
              component={ManagementOrders}
            />
            <Route
              path="/dashboard/:uid/products"
              exact
              component={ManagementProducts}
            />
            <Route
              path="/dashboard/:id/p/set-price"
              exact
              component={ProductDetail}
            />
            <Route path="/dashboard/:id/p" exact component={ProductDetail} />
            <Route
              path="/dashboard/:uid/p/:id"
              exact
              component={ProductDetail}
            />
            <Route
              path="/dashboard/:uid/p/:id/set-price"
              exact
              component={ProductDetail}
            />
            <Route
              path="/dashboard/:uid/cp/:id"
              exact
              component={ProductDetail}
            />
            <Route
              path="/dashboard/:uid/cp/:id/set-price"
              exact
              component={ProductDetail}
            />
            <Route
              path="/dashboard/:id/term-detail"
              exact
              component={TermDetail}
            />
            <Route
              path="/dashboard/:id/term-detail/:termId"
              exact
              component={TermDetail}
            />
            <Route path="/dashboard/:id/terms" exact component={ShopTerms} />
            <Route
              path="/dashboard/:uid/shopping-configs"
              exact
              component={ShoppingConfigs}
            />
            <Route
              path="/dashboard/:uid/new-shop-category"
              exact
              component={NewShopCategory}
            />
            <Route
              path="/dashboard/:uid/managers"
              exact
              component={ShopManagers}
            />
            <Route
              path="/dashboard/:uid/managers/:id"
              exact
              component={ManagersDetail}
            />
            <Route
              path="/dashboard/:id/activation"
              exact
              component={ShopActivation}
            />
            <Route
              path="/dashboard/:uid/customers"
              exact
              component={Customers}
            />
            <Route
              path="/dashboard/:uid/customers/:id"
              exact
              component={CustomerProfile}
            />
            <Route
              path="/dashboard/:uid/customer-cart/:cartId"
              exact
              component={CustomerCartsDetail}
            />
            <Route path="/dashboard/:id/edit" exact component={EditShop} />
            <Route
              path="/dashboard/:uid/connections/add"
              exact
              component={ConnectionDetail}
            />
            <Route
              path="/dashboard/:uId/connections/:id"
              exact
              component={ConnectionDetail}
            />
            <Route
              path="/dashboard/:uid/connections"
              exact
              component={ManagerConnections}
            />
            <Route path="/dashboard/:uid/payments" exact component={Payments} />
            <Route
              path="/dashboard/:uid/posting-methods"
              exact
              component={PostingMethods}
            />
            <Route
              path="/dashboard/:uid/posting-methods/:id"
              exact
              component={PostingMethodDetail}
            />
            <Route path="/dashboard/:uid/edit/map" exact component={EditShop} />
            <Route path="/dashboard/:id" exact component={DashBoard} />
            <Route path="/orders/:id" exact component={OrderDetail} />
            <Route path="/addresses/:uid" exact component={AddressDetail} />
            <Route path="/404" exact component={NotFound} />
            <Route path="/new-shop" exact component={AddShop} />
            <Route path="/categories" exact component={Categories} />

            {!isSiteDomain && <Route path="/:id" exact component={Shop} />}

            {isSiteDomain && <Route path="/cart" exact component={ShopCart} />}
            {!isSiteDomain && (
              <Route path="/:id/cart" exact component={ShopCart} />
            )}

            <Route path="/:id/products" exact component={Products} />

            {isSiteDomain && (
              <Route path="/order" exact component={CartOrder} />
            )}
            {!isSiteDomain && (
              <Route path="/:id/order" exact component={CartOrder} />
            )}

            {isSiteDomain && (
              <Route path="/factor/:cartUid" exact component={Factor} />
            )}
            {!isSiteDomain && (
              <Route path="/:id/factor/:cartUid" exact component={Factor} />
            )}

            {isSiteDomain && (
              <Route
                path="/personalized-product"
                exact
                component={PersonalizedProduct}
              />
            )}

            {!isSiteDomain && (
              <Route
                path="/:id/personalized-product"
                exact
                component={PersonalizedProduct}
              />
            )}

            {isSiteDomain && (
              <Route path="/p/:productId" exact component={Product} />
            )}
            {!isSiteDomain && (
              <Route path="/:id/p/:productId" exact component={Product} />
            )}

            {isSiteDomain && (
              <Route
                path="/p/:productId/add-comment"
                exact
                component={AddComment}
              />
            )}
            {!isSiteDomain && (
              <Route
                path="/:id/p/:productId/add-comment"
                exact
                component={AddComment}
              />
            )}

            <Route
              path="/:id/p/:productId/dashboard"
              exact
              component={Product}
            />

            <Route path="/:id/add-comment" exact component={AddComment} />
            <Route
              path="/payment/checkout/:id"
              exact
              component={AfterPayment}
            />
            <Route path="/page/:id" exact component={DynamicPage} />
            <Route path="/:uid/page/:id" exact component={DynamicPage} />
            <Route
              path="/dashboard/:uid/page/:id"
              exact
              component={DynamicPage}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;
